<div style="width: 0">
  <igx-dialog id="vtnGenerico" #vtnGenerico [closeOnOutsideSelect]="cerrarEnExteriorSeleccionar" [closeOnEscape]="cerrarEnEscape">
    <div class="header neo-dialog-shell-header">
      <div class="neo-dialog-header">
        <div class="neo-dialog-header__leading">
          <div class="neo-dialog-header__icon" [hidden]="icono.length === 0">
            <igx-icon>{{ icono }}</igx-icon>
          </div>
          <div class="neo-dialog-header__title">{{ titulo | translate }}</div>
        </div>
        <div class="neo-dialog-header__actions">
          @if (verExportar) {
            <button igxButton="contained" class="neo-dialog-header__action-button" (buttonClick)="eventoBtnExportar($event)" igxRipple="white">
              {{ 'MENSAJES.GRALS.EXPORTAR_EXCEL' | translate }}
            </button>
          }
          <button igxIconButton="flat" class="neo-dialog-header__button" [title]="textToolTip" (buttonClick)="fullscreen()" [hidden]="!verIconoMaxMin">
            <igx-icon>{{ textFullScreen }}</igx-icon>
          </button>
          <button igxIconButton="flat" class="neo-dialog-header__button" title="{{ 'BOTONES.CERRAR' | translate }}" (buttonClick)="cerrarVentana()" [hidden]="!verIconoCerrar">
            <igx-icon>close</igx-icon>
          </button>
        </div>
      </div>
    </div>
    <div class="vtn-generica__body" [style.width.px]="anchoTem" [style.height.px]="altoTem">
      <template #componente></template>
    </div>
    @if (this.btnsAccion.length > 0) {
      <div class="footer neo-dialog-footer">
        <div id="navBarFooter" class="neo-dialog-footer__actions neo-dialog-footer__actions--split">
          <div class="neo-dialog-footer__actions-left">
            @for (btn of btnsAccion; track btn) {
              @if (btn.posicion === 0) {
                <button title="{{ btn.titulo | translate }}" igxButton="{{ btn.tipoBoton }}" igxRipple class="{{ btn.class }}" (buttonClick)="onClickButton(btn)" [hidden]="btn.hidden">
                  @if (btn.icono.length > 0) {
                    <igx-icon>{{ btn.icono }}</igx-icon>
                  }
                  @if (btn.texto.length > 0) {
                    {{ btn.texto | translate }}
                  }
                </button>
              }
            }
          </div>
          <div class="neo-dialog-footer__actions-right">
            @for (btn of btnsAccion; track btn) {
              @if (btn.posicion === 1) {
                <button title="{{ btn.titulo | translate }}" igxButton="{{ btn.tipoBoton }}" igxRipple class="{{ btn.class }}" [hidden]="btn.hidden" (buttonClick)="onClickButton(btn)">
                  @if (btn.icono.length > 0) {
                    <igx-icon>{{ btn.icono }}</igx-icon>
                  }
                  @if (btn.texto.length > 0) {
                    {{ btn.texto | translate }}
                  }
                </button>
              }
            }
          </div>
        </div>
      </div>
    }
  </igx-dialog>
</div>
